// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null
}

const statsBeaconsStats = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        params: action.params
      }
    default:
      return { ...state }
  }
}
export default statsBeaconsStats
